import { Component, inject } from '@angular/core';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { WordingPipe } from '../../pipes/wording/wording.pipe';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'shared-user-offline',
  templateUrl: './user-offline.component.html',
  styleUrls: ['./user-offline.component.scss'],
  imports: [MatButtonModule, WordingPipe],
})
export class UserOfflineComponent {
  private _dialogRef = inject<MatDialogRef<UserOfflineComponent>>(MatDialogRef<UserOfflineComponent>);

  close(): void {
    this._dialogRef.close();
  }
}
